import { H2, H3, H4 } from "@maggioli-design-system/react";
import { useEffect } from "react";
import { scrollTop } from "../lib/Functions";

export default function Accessibility(): JSX.Element {

    useEffect(() => {
        scrollTop()
    }, [])

    return (
        <div className="px-8 background-color-adjust-tone-19 py-10">
            <div className="col-md-12 single-content view-limit">
                <H2>DICHIARAZIONE DI ACCESSIBILITÀ</H2>
                <H4>https://bibliotecadigitale.maggioli.it</H4>
                <div className="col-md-12 single-content text-size-sm mt-10 grid gap-8">
                    <p>
                        Modello di dichiarazione di accessibilità sito web e applicazione mobile per i soggetti
                        di cui all&apos;art. 3 comma 1-bis della legge 9 gennaio 2004, n.4.
                    </p>

                    <div>
                        <H3>
                            PREMESSA
                        </H3>
                        <p>
                            Maggioli S.p.A. si impegna a rendere il proprio sito web accessibile, conformemente alla legge 9
                            gennaio 2004, n. 4. La presente dichiarazione di accessibilità si applica al seguente sito web:
                            https://bibliotecadigitale.maggioli.it.
                        </p>
                    </div>

                    <div>
                        <H3>
                            STATO DI CONFORMITÀ
                        </H3>
                        <p>
                            Questo sito web è Parzialmente conforme ai requisiti previsti dall&apos;appendice A della norma UNI CEI
                            EN 301549. I casi di non conformità sono elencati di seguito.
                        </p>
                    </div>

                    <div>
                        <H3>
                            CONTENUTI NON ACCESSIBILI
                        </H3>
                        <p>
                            I contenuti di seguito elencati non sono accessibili per i seguenti motivi:
                        </p>
                    </div>

                    <p>
                        <strong>a) Inosservanza della legge 9 gennaio 2004, n. 4.</strong>
                    </p>
                    <ul className="list-disc ml-10">
                        <li>
                            <strong>Requisito: 9.1.3.1 / Wcag 1.3.1</strong> - Informazioni, struttura o relazioni trasmesse dalla
                            presentazione delle pagine, non possono essere determinate programmaticamente o non sono
                            disponibili tramite testo.
                        </li>
                        <li>
                            <strong>Requisito: 9.1.4.3 / Wcag 1.4.3</strong> - La rappresentazione visiva del testo e di immagini
                            contenenti testo non ha sempre il rapporto minimo di contrasto richiesto.
                        </li>
                        <li>
                            <strong>Requisito: 9.2.1.1 / Wcag 2.1.1</strong> - Alcune funzionalità non possono essere utilizzabili tramite
                            tastiera.
                        </li>
                        <li>
                            <strong>Requisito: 9.3.3.1 / Wcag 3.3.1</strong> - Su alcuni elementi in cui il contenuto richiede inserimento
                            di dati da parte dell&apos;utente, se viene rilevato automaticamente un errore di input, l&#39;elemento in
                            errore non viene identificato e l&#39;errore non viene descritto all&#39;utente in forma testuale.
                        </li>
                        <li>
                            <strong>Requisito: 9.3.3.2 / Wcag 3.3.2</strong> - Su alcuni elementi in cui il contenuto richiede inserimento
                            di dati da parte dell&apos;utente, alcuni campi obbligatori non sono indicati esplicitamente.
                        </li>
                        <li>
                            <strong>Requisito: 9.4.1.2 / Wcag 4.1.2</strong> - In alcuni casi i componenti dell&#39;interfaccia utente (fra cui:
                            modali, elementi di un modulo, collegamenti e componenti generati da script…), nome,
                            ruolo, stati, proprietà e valori non sono corretti o impostati o non è avvisato l&#39;utente e le sue
                            tecnologie assistive quando questi cambiano.
                        </li>
                        <li>
                            <strong>Documenti: </strong> I documenti PDF scaricabili all&apos;interno del sito web potrebbero non essere
                            strutturati o taggati adeguatamente per permetterne un uso accessibile.
                        </li>
                    </ul>
                    <p >
                        Non sono attualmente predisposte alternative accessibili in quanto <span className="underline font-bold">ci si impegna ad applicare
                        azioni specifiche per la risoluzione delle problematiche riscontrate.</span>
                    </p>
                    <p >
                        In caso di necessità di accedere a contenuti che risultano non accessibili, l&apos;utente può inviare una
                        richiesta alla casella e-mail <strong>supporto.accessibilita@maggioli.it</strong>, per richiedere di accedere al
                        contenuto in modalità alternativa.
                    </p>
                    <p >
                        Maggioli S.p.A. fornirà un riscontro entro i termini previsti, documentati nell&apos;Allegato 1 alle Linee
                        Guida sull&apos;accessibilità degli strumenti informatici, sezione “Modalità di Invio delle Segnalazioni e
                        Recapiti del Soggetto Erogatore”, pubblicata dal Agenzia per l&apos;Italia Digitale.
                    </p>

                    <div>
                        <H3>REDAZIONE DELLA DICHIARAZIONE DI ACCESSIBILITÀ</H3>
                        <p>
                            La presente dichiarazione è stata redatta in data 21/09/2026. <br />
                            Le informazioni presenti nella dichiarazione sono state ricavate utilizzando una valutazione
                            effettuata da terzi tramite analisi oggettive e soggettive su campione rappresentativo delle
                            funzionalità.
                        </p>
                    </div>

                    <div>
                        <H3>MODALITÀ DI INVIO DELLE SEGNALAZIONI E RECAPITI DEL SOGGETTO EROGATORE</H3>
                        <p>
                            Maggioli S.p.A. mette a disposizione il meccanismo di feedback da utilizzare per notificare i casi di mancata
                            conformità e per richiedere informazioni e contenuti che sono esclusi dall&#39;ambito di applicazione
                            della direttiva.
                        </p>
                    </div>

                    <p>
                       <strong>Meccanismo di feedback</strong>: inviare e-mail a <strong>supporto.accessibilita@maggioli.it</strong><br />
                        Nell&#39;e-mail è necessario indicare:
                        <ul className="list-disc ml-10">
                            <li>Nome e cognome (specificando se già utente di Maggioli S.p.A.);</li>
                            <li>Indirizzo della pagina web o sezioni del sito oggetto della segnalazione;</li>
                            <li>Descrizione chiara e sintetica del problema riscontrato;</li>
                            <li>Strumenti utilizzati (sistema operativo, browser, tecnologie assistive);</li>
                            <li>Sistema Operativo utilizzato (Windows; Linux; Mac OS; altro);</li>
                            <li>Browser utilizzato (Safari; Chrome; Edge; altro);</li>
                            <li>Dispositivo utilizzato (Smartphone; PC; Tablet; altro).</li>
                        </ul>
                    </p>

                    <div>
                        <H3>MODALITÀ DI INVIO DELLE SEGNALAZIONI ALL&apos; AGENZIA PER L&apos;ITALIA DIGITALE (AGID)</H3>
                        <p>
                            In caso di risposta insoddisfacente o di mancata risposta, nel termine di trenta giorni, l&apos;interessato
                            può inoltrare una segnalazione utilizzando il seguente link:  <a className="underline" href="https://www.agid.gov.it/it" target="_blank" rel="noreferrer">https://www.agid.gov.it/it</a>.
                        </p>
                    </div>

                    <div>
                        <H3>INFORMAZIONI SUL SITO</H3>
                        <ol className="ml-10 list-decimal">
                            <li>Data della pubblicazione del sito web: 22/09/2026</li>
                            <li>Sono stati effettuati test di usabilità? NO</li>
                            <li>Content Management System (CMS) utilizzato: nessuno</li>
                        </ol>
                    </div>


                    <div>
                        <H3>INFORMAZIONI SULLA STRUTTURA</H3>
                        <ol className="ml-10 list-decimal">
                            <li>Il numero di dipendenti con disabilità presenti nell&apos;amministrazione: 72</li>
                            <li>Numero di postazioni di lavoro per dipendenti con disabilità: 0</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
}
